import React from "react";
import { Navbar } from "../componentes/navbar";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import img404 from "../404.png"; 
export const Pagina404 = () => {

  const navigate = useNavigate();

  return (
    <>
      {/* Navbar */}


      {/* Contenido de la página 404 */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
          textAlign: "center",
          padding: "20px",
        }}
      >
        {/* Imagen */}
        <img
          src={img404}
          alt="404"
          style={{ width: "30em", marginBottom: "20px" }}
        />

        {/* Texto */}
        <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>
          ¡Página no encontrada!
        </h1>
        <p style={{ fontSize: "1rem", color: "#666", marginBottom: "20px" }}>
          Lo sentimos, la página que buscas no existe.
        </p>

        {/* Botón para ir al Home */}
        <Button className="boton-principal
        "
          type="primary"
          size="large"
          onClick={() => navigate("/")} 
        >
          Ir al Inicio
        </Button>
      </div>
    </>
  );
};